// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__WVo+8","title":"Navbar_title__1U1Rl","theme":"Navbar_theme__baARn","themeValues":"Navbar_themeValues__a+Lvk","datalist":"Navbar_datalist__MdJLC"};